import { fields, createSchema, validate as _validate } from '..';

const { requiredText } = fields;

const schema = createSchema({
  comment: requiredText,
});

const validate = (data) => _validate(schema, data);

export default validate;
